import styled from 'react-emotion'

import themeVars from 'ui_theme/site/globals/site.variables'

export default styled(({ className }) => {
  return <span className={className}>(optional)</span>
})`
  color: ${themeVars.ultraLight};
`
